<script setup lang="ts">
import CanvassDetails from "@/canvasses/CanvassDetails.vue";
import type { Canvass } from "@/canvasses/types";
import { LogOut } from "@iconoir/vue";
import { RouterLink } from "vue-router";

defineProps<{
  canvass: Canvass;
}>();
</script>

<template>
  <main class="container container-md">
    <div class="column column-lg box">
      <CanvassDetails :canvass />

      <RouterLink
        :to="{ name: 'home' }"
        class="button button--secondary back-button"
      >
        <LogOut /> Zurück zur Aktionsübersicht
      </RouterLink>
    </div>
  </main>
</template>

<style scoped>
.back-button {
  inline-size: 100%;
  justify-content: center;
}
</style>
